import { combineLatest, map, of } from 'rxjs';
import { memo } from '../util/index.js';
import { getEraCache, setEraCache } from './cache.js';
import { combineEras, erasHistoricApply, singleEra } from './util.js';
const CACHE_KEY = 'eraSlashes';
function mapSlashes(era, noms, vals) {
  const nominators = {};
  const validators = {};
  noms.forEach(_ref => {
    let [key, optBalance] = _ref;
    nominators[key.args[1].toString()] = optBalance.unwrap();
  });
  vals.forEach(_ref2 => {
    let [key, optRes] = _ref2;
    validators[key.args[1].toString()] = optRes.unwrapOrDefault()[1];
  });
  return {
    era,
    nominators,
    validators
  };
}
export function _eraSlashes(instanceId, api) {
  return memo(instanceId, (era, withActive) => {
    const [cacheKey, cached] = getEraCache(CACHE_KEY, era, withActive);
    return cached ? of(cached) : combineLatest([api.query.staking.nominatorSlashInEra.entries(era), api.query.staking.validatorSlashInEra.entries(era)]).pipe(map(_ref3 => {
      let [n, v] = _ref3;
      return setEraCache(cacheKey, withActive, mapSlashes(era, n, v));
    }));
  });
}
export const eraSlashes = /*#__PURE__*/singleEra('_eraSlashes');
export const _erasSlashes = /*#__PURE__*/combineEras('_eraSlashes');
export const erasSlashes = /*#__PURE__*/erasHistoricApply('_erasSlashes');